import _ from 'lodash';
import { Enum, EnumType } from 'ts-jenum';

@Enum<SliderEnum>('value')
export class SliderEnum extends EnumType<SliderEnum>() {
   static readonly strict = new SliderEnum(0, 100, 'phonetic.slider.strict');

   static readonly balanced = new SliderEnum(1, 70, 'phonetic.slider.balanced');

   static readonly loose = new SliderEnum(2, 30, 'phonetic.slider.loose');
   static readonly veryLoose = new SliderEnum(3, 0, 'phonetic.slider.very-loose');

   static getValues(): SliderEnum[] {
      return _(SliderEnum.values()).value();
   }

   constructor(public value, public percent, public translationValue) {
      super();
   }
}
